
import Handsontable from "handsontable";
import { RateItem } from "../../models";

/*
Custom renderer for dropdown cells that have validation errors in rate item processing.

 * @param hot The Handsontable instance.
 * @param td The table cell.
 * @param row The row index.
 * @param column The column index.
 * @param prop The property.
 * @param value The value.
 * @param cellProperties The cell properties.
 */
export function isgRendererDropDownValidation(
  this: any
  , hot: Handsontable
  , td: any
  , row: number
  , column: number
  , prop: any
  , value: any
  , cellProperties: any) {

  const args: [Handsontable, any, number, number, string | number, any, Handsontable.CellProperties] =
    [hot, td, row, column, prop, value, cellProperties];

  Handsontable.renderers.DropdownRenderer.apply(this, args);

  const phRow = hot.toPhysicalRow(row);

  // hot.getPlugin('Filters').trimRowsPlugin.rowsMapper.__arrayMap[row]
  let val :any = hot.getDataAtRowProp(row, "idxFail");

  if (!val) {
    // this is customized for IT services matrix processing
    val = hot.getDataAtRowProp(row, "colFail");
    if (val && val > 0) {      

      if (val == column)
        td.style.backgroundColor = '#ffbeba';
    }
  }
  //const val: any = hot.getSourceDataAtCell(row, column "idxFail");
  else {
    if (val && val > 0) {

      // this is customized for rate item processing
      const colProp: any = hot.colToProp(column);

      const match = colProp.match(/^idxVal(\d+)$/);
      const idx = match ? parseInt(match[1], 10) : 0;

      if (val == idx)
        td.style.backgroundColor = '#ffbeba';
    }
  }

}
